import { useDeletePresetMutationApi } from '@aibees/shared/api';
import { useCreateOrUpdatePresetMutation } from '@aibees/shared/api/preset/use-create-or-update-preset-mutation';
import { useTableLayoutTemplateContext } from '@aibees/shared/features/advance-table/components/table-layout-modifier-dialog/context';
import { useAdvanceTableContext } from '@aibees/shared/features/advance-table/context';
import { classnames } from '@aibees/shared/utils';
import { Button } from '@mui/material';
import { memo } from 'react';
import * as Styled from './styles';
import * as SX from './sx';
import type { ChooseTemplateFooterProps as Props } from './types';

export const TableLayoutModifierDialogFooter = memo(
  ({ className, dialogState }: Props) => {
    const { config } = useAdvanceTableContext();

    const { id, selectedPreset, setAppliedId, isApplyDisabled, templates } =
      useTableLayoutTemplateContext();

    const api = useCreateOrUpdatePresetMutation<string>(
      'SELECTED_'.concat(config.columnModifierPresetType!),
      false
    );

    const deleteApi = useDeletePresetMutationApi(selectedPreset?.id);

    const handleApply = () => {
      if (id) {
        const selectedTemplateName =
          templates.find((t) => t.id === id)?.name ?? '';
        api.mutateAsync(
          id,
          'SELECTED_'.concat(config.columnModifierPresetType ?? ''),
          selectedTemplateName
        );
        setAppliedId(id);
      } else if (selectedPreset?.id) {
        deleteApi.mutateAsync(null);
        setAppliedId(undefined);
      }
      dialogState.onClose();
    };

    const handleCancel = () => {
      dialogState.onClose();
    };

    return (
      <Styled.Wrapper
        className={classnames('TableLayoutModifierDialogFooter', className)}
        sx={SX.root}
        direction="row"
        justifyContent="flex-end"
        gap={1}
      >
        <Button sx={SX.button} onClick={handleCancel}>
          Cancel
        </Button>
        <Button
          sx={SX.button}
          variant="outlined"
          color="primary"
          onClick={handleApply}
          disabled={isApplyDisabled}
        >
          Apply
        </Button>
      </Styled.Wrapper>
    );
  }
);

TableLayoutModifierDialogFooter.displayName = 'ChooseTemplateFooter';
